/**
 * Extracts the area code from the given phone number. This method will handle most US formats such as:
 * +1 (801)-444-5555
 * 1 (801)-444-5555
 * (801) 444-5555
 * 801-444-5555
 * 18014445555
 * 8014445555
 *
 * This method will return "801" for all of the above examples.
 *
 * @param phoneNumber The phone number as a string.
 * @returns {string} The extracted area code OR an empty string if area code can not be extracted.
 */
export function getAreaCode(phoneNumber) {
  // First remove everything that is not a digit
  const digits = phoneNumber.replace(/\D/g, "")

  let areaCode = ""
  if (digits.length === 11) {
    // Get the first 3 digits after the leading "1"
    areaCode = digits.substr(1, 3)
  } else if (digits.length === 10) {
    // Get the first 3 digits
    areaCode = digits.substr(0, 3)
  } else {
    // Invalid phoneNumber
    console.warn("getAreaCode: Invalid phoneNumber [" + phoneNumber + "]")
  }
  return areaCode
}


// WEBPACK FOOTER //
// ./src/Helpers/phoneNumber.js